import { theme, VerticalSpacer, Img as ImgComponent } from '@superhi/design'
import { ResponsiveBreakpoint } from '@superhi/design/dist/cjs/theme/media'
import styled from 'styled-components'

const CARD_PADDING: Record<ResponsiveBreakpoint, number> = {
  small: 24,
  medium: 32,
  large: 48,
}

const PADDING: Record<ResponsiveBreakpoint, number> = {
  small: 52,
  medium: 112,
  large: 136,
}

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${theme.colors.WHITE};
  padding: ${PADDING.small - CARD_PADDING.small}px 0;

  > * {
    width: 100%;
  }

  @media ${theme.breakpoints.medium} {
    padding: ${PADDING.medium - CARD_PADDING.medium}px 0;
  }

  @media ${theme.breakpoints.large} {
    padding: ${PADDING.large - CARD_PADDING.large}px 0;
  }
`

export const OneOffMessageWrapper = styled.div`
  text-align: center;
`

export const ButtonWrapper = styled.div`
  padding: 16px;
  background-color: ${theme.colors.PALE_BLUE_40};
  border-radius: 10px;
  text-align: center;

  @media ${theme.breakpoints.medium} {
    padding: 24px;
  }
`

type ImageWrapperProps = {
  $backgroundColor: keyof typeof theme.colors
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
  display: block;
  background-color: ${({ $backgroundColor }) => theme.colors[$backgroundColor]};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const ContentWrapper = styled.div`
  position: relative;
`

export const Info = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: -4px -8px;

  > * {
    margin: 4px 8px;
  }
`

export const Img = styled(ImgComponent)`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;

  img {
    && {
      position: absolute !important;
    }
  }
`

export const Card = styled(VerticalSpacer).attrs({
  amount: { small: 24, medium: 24, large: 32 },
})`
  position: relative;
  z-index: 2;
  background-color: ${theme.colors.WHITE};
  width: 100%;
  padding: 24px;
  border-radius: 10px;
  max-width: 640px;

  @media ${theme.breakpoints.medium} {
    padding: 32px;
  }

  @media ${theme.breakpoints.large} {
    padding: 48px;
    max-width: 640px;
  }
`

export const Buttons = styled.div`
  display: flex;
  margin: -4px;

  flex-direction: column;

  @media ${theme.breakpoints.medium} {
    flex-direction: row;
  }

  > * {
    margin: 4px;
  }
`
